var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophoneWithoutOpacity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5583C0 15.6127 2.53578 18.4571 6.26119 18.7881V20.4686L6.26339 21.2644C6.26452 21.671 6.59447 22 7.0011 22C7.40853 22 7.73882 21.6697 7.73882 21.2623V20.4686V18.7881C11.4767 18.4571 14 15.6127 14 11.5583V10.4587C14 10.0244 13.6776 9.68286 13.2675 9.68286C12.8542 9.68286 12.5224 10.0244 12.5224 10.4587V11.4961C12.5224 15.023 10.3497 17.3606 7.00627 17.3606C3.65027 17.3606 1.47763 15.023 1.47763 11.4961V10.4587C1.47763 10.0244 1.15518 9.68286 0.735682 9.68286C0.322443 9.68286 0 10.0244 0 10.4587V11.5583Z",
    fill: "#0F7BBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.00771 16C9.39543 16 11 14.3711 11 12.0425V3.9578C11 1.61804 9.39543 0 7.00771 0C4.60847 0 3 1.61804 3 3.9578V12.0425C3 14.3711 4.60847 16 7.00771 16Z",
    fill: "#0F7BBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneWithoutOpacity);
export default __webpack_public_path__ + "static/media/MicrophoneWithoutOpacity.5417577f05fd73ff97793bcdbfcd8d1e.svg";
export { ForwardRef as ReactComponent };